import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getTemplates, getNewTemplateId } from 'store/selectors/templates';
import { addTemplate } from 'store/actions/templates';
import SelectTemplate from './SelectTemplate';

const selector = createStructuredSelector({
  templates: getTemplates,
  newTemplateId: getNewTemplateId,
});

const action = {
  onAddTemplate: addTemplate,
};

export default connect(
  selector,
  action,
)(SelectTemplate);
